/* Uberflip GWL OB-6702 start here */
function filterTileAnim() {
    const liTags = document.querySelectorAll('#collection-items .tile');
    if (liTags) {
        liTags.forEach((item) => {
            item.classList.add('animated');
        });
    }
    const filterBox = document.querySelectorAll('#collection-items .filter-box');
    if (filterBox) {
        filterBox.forEach((box) => {
            box.classList.add('animated');
        });
    }

}
export { filterTileAnim };
/* Uberflip GWL OB-6702 end here */


// WEBPACK FOOTER //
// ./scriptPartials/filter/tileAnimation.js